import { itx } from "../../translationItx/itx";
import { SequenceStep, enumActions } from "../Guide";
import { ToDoItem } from "../ToDoItem";

// ContextMenuLables.addFloors
function sequence(type: string, lastToDoItem?: ToDoItem): Array<SequenceStep> {
  return [
    {
      action: enumActions.call,
      subSequence: () => {
        const page = state.objectRegistry.getObject(state.activePaneId);
        if (type == "Scene" && page?.parent?.className == "Room" && false) {
          // der kleine dialog feld ist nicht zu sehen
          return [
            {
              id: "SceneGroup_addNewScene",
              action: enumActions.mousedown,
            },
            {
              action: enumActions.wait, // wait until dialog is open
            },
            {
              id: ["newSceneEditor", "sceneName"], // no itx
              action: enumActions.click,
            },
            {
              action: enumActions.call,
              subSequence: () => {
                // calc here the name and tag
                let choosenName = "Szene"; // no itx
                let allPossibleName = [
                  itx("defaultCabinetAndScenes.living", "Wohnen"),
                  itx("defaultCabinetAndScenes.eating", "Essen"),
                  itx("defaultCabinetAndScenes.cooking", "Kochen"),
                  itx("defaultCabinetAndScenes.sleeping", "Schlafen"),
                ];
                allPossibleName.forEach((possibility) => {
                  let allreadyInProject = false;
                  state.allScenes().forEach((scene) => {
                    if (scene.name == possibility) {
                      allreadyInProject = true;
                    }
                  });
                  if (!allreadyInProject && choosenName == "Szene") {
                    choosenName = possibility;
                  }
                });

                return [
                  {
                    id: ["newSceneEditor", "sceneName"], // no itx
                    action: enumActions.type,
                    text: choosenName, // itx("onBoardingSequences.nameNewRoom", "Ein Neuer Raum"),
                  },
                ];
              },
            },
            {
              action: enumActions.click,
              id: ["newSceneEditor", "createSceneButton"], // no itx
            },
          ];
        } else {
          return [
            {
              id: () => {
                return `tv-${state.sceneGroup.id}`;
              },
              action: enumActions.focus,
            },
            {
              id: () => {
                return [`tv-${state.sceneGroup.id}`, "inlineButton_addSceneOrMultiplexer"]; // no itx
              },
              action: enumActions.click,
            },
            {
              action: enumActions.clickContextMenuItem,
              index: type == "Scene" ? 1 : 2,
            },
          ];
        }
      },
    },
  ];
}

export default sequence;
